import { render, staticRenderFns } from "./xscjtj.vue?vue&type=template&id=4a880eea&scoped=true"
import script from "./xscjtj.vue?vue&type=script&lang=js"
export * from "./xscjtj.vue?vue&type=script&lang=js"
import style0 from "./xscjtj.vue?vue&type=style&index=0&id=4a880eea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a880eea",
  null
  
)

export default component.exports